import Icon from './Icon.jsx';
import s from './FAB.module.css';

export default function FAB({ icon = 'plus', label, onClick, ...rest }) {
  return (
    <button
      type="button"
      className={s.fab}
      aria-label={label || 'Add'}
      onClick={onClick}
      {...rest}
    >
      <span className={s.ring} aria-hidden="true" />
      <Icon name={icon} size="lg" className={s.icon} />
    </button>
  );
}
